// src/components/atoms/Button/Button.tsx
import React from 'react';
import clsx from 'clsx'; // tailwind 쓸 땐 필수임
import { button } from './Button.css'; // .css.ts 확장자를 자동 인식하도록 설정되어 있다면 .css만 써도 됩니다

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  size?: 'small' | 'default' | 'large'; /** 버튼 크기 */
  intent?: 'primary' | 'secondary' | 'danger';/** 버튼 용도 */
  outline?: boolean; /** 아웃라인 모드 */
  text?: boolean; /** 텍스트 모드 (배경 없이 텍스트 색상만) */
  className?: string; // 외부에서 넣는 클래스 받기
}

export const Button: React.FC<ButtonProps> = ({
  size = 'default',
  intent = 'primary',
  outline = false,
  text = false,
  className,
  children,
  ...rest
}) => {
  return (
    <button
      className={clsx(button({ size, intent, outline, text }), className)}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;